<template>
  <div class="drawer">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Drawer'
}
</script>

<style lang="sass">
.drawer
  width: 100%
  padding: 5px
  background: #fff
  border-top: solid 1px #9d9d9d
  > p
    line-height: 7px
</style>
